import { useEffect } from "react";
import { SpinnerLoader } from "@ucchub/ui";
import DashShell from "@components/common/DashShell";
import { Crumbs } from "@ucchub/ui";
import breadCrumbs from "@json/common/crumbs.json";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import Container from "@vfuk/core-container";
import EditCustomerForm from "@components/forms/CustomersForm/EditCustomerForm";
import useCustomerDetails from "@hooks/customer/useCustomerDetails";
import CustomerBanner from "@components/customer/CustomerBanner";
import CustomerError from "@components/customer/CustomerError";
import { OrganisationStatus } from "@components/customer/Customer.types";

const NewEditCustomer = () => {
  const { t } = useTranslation();
  const { customerId } = useParams();
  const {
    customerDetails,
    error,
    customerProducts,
    isCustomerLoading,
    fetchCustomerDetails,
  } = useCustomerDetails();
  const headText = isCustomerLoading
    ? t("core:customers:loading")
    : customerDetails?.name;

  useEffect(() => {
    if (customerId) fetchCustomerDetails(customerId);
  }, [customerId]);

  return (
    <DashShell>
      <Crumbs items={breadCrumbs.view_customers} />
      <CustomerBanner
        pid={customerDetails?.pid}
        headText={headText || ""}
        status={customerDetails?.status}
      />
      {error && <CustomerError error={error} />}
      <Container appearance="secondary">
        {isCustomerLoading && (
          <SpinnerLoader
            srText={
              t("core:customers:loading_customer_details") ||
              "Loading customer details"
            }
            text={
              t("core:customers:loading_customer_details") ||
              "Loading customer details"
            }
          />
        )}

        {!isCustomerLoading &&
          customerId &&
          customerDetails &&
          !error &&
          customerDetails.status !== OrganisationStatus.DRAFT && (
            <EditCustomerForm
              isEdit
              customerId={customerId}
              customer={customerDetails}
              products={customerProducts}
            />
          )}
        {customerDetails?.status === OrganisationStatus.DRAFT &&
          !isCustomerLoading && (
            <CustomerError
              error={t("core:customers:failed_to_load_customer_edit")}
            />
          )}
      </Container>
    </DashShell>
  );
};

export default NewEditCustomer;
